import { Component, inject } from '@angular/core';
import { RedemptionResponse } from '../../core/Interfaces/Http/redemption-response';
import { RedemptionService } from '../../core/services/redemption.service';
import { MatCard, MatCardContent } from '@angular/material/card';
import { DeliveryComponent } from './delivery/delivery.component';
import { FetchComponent } from './fetch/fetch.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { SettingsService } from '../../core/services/settings.service';

@Component({
  selector: 'app-redemptions',
  imports: [
    MatCard,
    MatCardContent,
    DeliveryComponent,
    FetchComponent,
    NotfoundComponent,
  ],
  templateUrl: './redemptions.component.html',
  styleUrl: './redemptions.component.scss',
})
export class RedemptionsComponent {
  private redemptionService = inject(RedemptionService);
  private settingsService = inject(SettingsService);

  redemptions: RedemptionResponse[] = [];
  constructor() {
    this.redemptionService.getRedemptions().subscribe({
      next: (value) => {
        this.addRedemption(value);
      },
    });

    this.redemptionService.clear().subscribe({
      next: () => {
        this.clearRedemption();
      },
    });
  }

  private clearRedemption(): void {
    this.redemptions = [];
  }

  private addRedemption(redemption: RedemptionResponse) {
    this.redemptions.push(redemption);

    const settings = this.settingsService.getValue();
    this.redemptions = this.redemptions
      .reverse()
      .filter(
        (obj1, i, arr) =>
          arr.findIndex(
            (obj2) => obj2.redemptionCode === obj1.redemptionCode,
          ) === i,
      )
      .reverse();

    if (settings.redemptionQueSize) {
      if (this.redemptions.length > settings.redemptionQueSize) {
        this.redemptions.splice(0, 1);
      }
    } else {
      if (this.redemptions.length > 10) {
        this.redemptions.splice(0, 1);
      }
    }
  }
}
